import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import { HeadingWithFlameHighlights } from '@components/heading-with-flame-highlights';
import { Box } from '../../grid';
import { P } from '../../typography/new';
import { ProductSizesGroup } from './product-sizes-group';
import { SizesPropType } from './prop-types';
import { StylePicker } from '../../style-picker';
import { useFeature } from '../../../hooks/use-feature';

const ProductSizePicker = observer(({ sizes, onChange, value, showDisclaimer }) => {
  const isNewProductSizePickerEnabled = useFeature('new-size-picker');

  if (isNewProductSizePickerEnabled) {
    return (
      <Box
        bg="warmWhite100"
        borderTopLeftRadius="32px"
        borderTopRightRadius="32px"
        display="flex"
        flexDirection="column"
        gap="24px"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        minWidth="520px"
        pb="32px"
        px={{ xs: '16px', md: '32px' }}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap="24px"
          alignItems="flex-start"
          justifyContent="flex-start"
          width="100%"
        >
          <Box display="flex" gap="24px" alignItems="center" justifyContent="flex-start">
            <HeadingWithFlameHighlights mb="0" heading="Select size" variant="section" />
          </Box>
          <ProductSizesGroup sizes={sizes} value={value} onChange={onChange} />
        </Box>
        {showDisclaimer && (
          <P variant="small" textAlign="center" width="100%" maxWidth="456px" margin="0">
            The average adult daily energy intake is 8,700kJ.
          </P>
        )}
      </Box>
    );
  }

  return (
    <StylePicker
      title="Size"
      type="radio"
      required
      items={sizes.map(product => ({
        text: product.prices.formattedPrice,
        label: product.size,
        value: product.id,
      }))}
      selectedItems={value === undefined ? [] : [value]}
      onSelect={newOptions => {
        const selectedOption = newOptions[0];

        onChange(selectedOption.value);
      }}
    />
  );
});

ProductSizePicker.propTypes = {
  sizes: SizesPropType,
  showDisclaimer: PropTypes.bool,
};

ProductSizePicker.defaultProps = { showDisclaimer: false };

export { ProductSizePicker };
